import React from 'react';
import { useParams } from 'react-router-dom';
import { Stack } from 'rsuite';
import EshopSetupAllegroAddressEdit from '../components/EshopSetup/Allegro/EshopSetupAllegroAddressEdit';
import { ApiGroup } from '../api/model/ApiGroup';
import EshopSetupAlzaBranchEdit from '../components/EshopSetup/Alza/EshopSetupAlzaBranchEdit';
import EshopSetupKauflandWarehouseEdit from '../components/EshopSetup/Kaufland/Warehouse/Edit/EshopSetupKauflandWarehouseEdit';

interface ContextProps {
  apiGroup: ApiGroup;
  marketplaceCode: string;
  warehouseLocalityId?: number;
}

function Context(
  { apiGroup, marketplaceCode, warehouseLocalityId }: ContextProps,
): JSX.Element | null {
  switch (apiGroup) {
    case ApiGroup.ALLEGRO:
      return (
        <EshopSetupAllegroAddressEdit
          warehouseLocalityId={warehouseLocalityId}
          marketplaceCode={marketplaceCode}
        />
      );
    case ApiGroup.ALZA:
      return (
        <EshopSetupAlzaBranchEdit
          warehouseLocalityId={warehouseLocalityId}
          marketplaceCode={marketplaceCode}
        />
      );
    case ApiGroup.KAUFLAND:
      return (
        <EshopSetupKauflandWarehouseEdit
          warehouseLocalityId={warehouseLocalityId}
          marketplaceCode={marketplaceCode}
        />
      );
    default:
      return null;
  }
}

Context.defaultProps = {
  warehouseLocalityId: undefined,
};

export default function WarehouseLocalityEdit(): JSX.Element | null {
  const { apiGroup, marketplaceCode, warehouseLocalityId } = useParams();
  const parsedWarehouseLocalityId = warehouseLocalityId ? Number(warehouseLocalityId) : undefined;

  if (!marketplaceCode || !apiGroup || !(apiGroup in ApiGroup)) {
    return null;
  }

  let title = `${parsedWarehouseLocalityId ? 'Edit' : 'Add'}`;
  if (apiGroup === ApiGroup.ALLEGRO) {
    title += ` dispatch address for ${marketplaceCode}`;
  }
  if (apiGroup === ApiGroup.ALZA) {
    title += ` branch for ${marketplaceCode}`;
  }
  if (apiGroup === ApiGroup.KAUFLAND) {
    title += ` warehouse for ${marketplaceCode}`;
  }

  return (
    <div className="m-10" style={{ marginBottom: 150 }}>
      <Stack direction="column" alignItems="stretch" spacing={15} justifyContent="flex-start">
        <h4>{title}</h4>
        <Context
          apiGroup={apiGroup as ApiGroup}
          marketplaceCode={marketplaceCode}
          warehouseLocalityId={parsedWarehouseLocalityId}
        />
      </Stack>
    </div>
  );
}
